import React, { useMemo, useState } from "react";
import {
  Dropdown as DropdownRS,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Spinner,
} from "reactstrap";
import { Direction } from "reactstrap/es/Dropdown";

type Props = {
  selectedValue?: number;
  options: { id: number; name: string }[];
  size?: "sm";
  direction?: Direction;
  type: string;
  onChange: ({ id, name }: { id: number; name: string }) => void;
  isDisabled?: boolean;
  loading?: boolean;
};

const DropDown = ({
  size,
  direction,
  selectedValue,
  options,
  type,
  onChange,
  isDisabled,
  loading
}: Props) => {
  const [showDropDown, setShowDropDown] = useState(false);
  const selectVal = useMemo(
    () => options?.filter((e) => e.id === selectedValue)[0],
    [options, selectedValue]
  );
  return (
    <DropdownRS
      size={size || "sm"}
      isOpen={showDropDown}
      direction={direction || "down"}
      toggle={() => setShowDropDown((prevState) => !prevState)}
      disabled={isDisabled}
    >
      <DropdownToggle caret>
        {selectedValue ? (
          <span>
            {type}:
            <span className="text-primary text-capitalize px-2">
              {selectVal?.name?.slice(0, 20)}
            </span>
          </span>
        ) : (
          <span>{`Select ${type || "value"}`}</span>
        )}
      </DropdownToggle>
      <DropdownMenu style={{ maxHeight: "90vh", overflowY: "auto" }}>
        {loading
          ?
          <div className="w-100 d-flex justify-content-between">
            <Spinner
              size="sm"
            />
          </div>
          :
          options?.length !== 0 ? (
            options?.map((each, index) => (
              <DropdownItem
                key={index}
                onClick={() => {
                  onChange(each);
                }}
              >
                <span className="d-flex justify-content-between align-items-center">
                  {each?.name}
                  {selectVal?.id === each?.id && (
                    <i className="fas fa-check-circle text-primary"></i>
                  )}
                </span>
              </DropdownItem>
            ))
          ) : (
            <span className="small text-muted text-center">
              No {type || "Options"} Available
            </span>
          )}
      </DropdownMenu>
    </DropdownRS>
  );
};

export default DropDown;
